import script from "./paymentDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./paymentDetail.vue?vue&type=script&setup=true&lang=ts"

import "./paymentDetail.vue?vue&type=style&index=0&id=7d1292d2&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d1292d2"]])

export default __exports__